// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"829":"bc0e3fcb","997":"3d9d9713"}[chunkId] + ".chunk.js";
};